import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository, Not, QueryResult } from "typeorm";
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object";
import { RacksAdapter } from "./rack.adaptor";
import { RacksEntity } from "./rack.entity";
import { RacksDTO } from "./rack.dto";
import { CommonResponseModel, RacActiveDeactive, RackCreateRequest, RackIdReq, Rackreq, UnitReq } from "@project-management-system/shared-models";
import { RackPositionEntity } from "../rm_locations/rack-position.entity";
import { EmployeeDetailsRepo } from "../employee-details/dto/employee-detail-repository";
import { EmployeeBuyerMappingService } from "../employee-buyer-mapping/employee-buyer-mapping.service";

@Injectable()
export class RacksService {

  constructor(
    private adapter: RacksAdapter,
    @InjectRepository(RacksEntity)
    private repository: Repository<RacksEntity>,
    private employeeDetailsRepo:EmployeeDetailsRepo,
        private employeeBuyerMappingService:EmployeeBuyerMappingService,
  ) { }

  async createRacks(createDto: RacksDTO): Promise<CommonResponseModel> {
    try {
      const record = await this.repository.findOne({ where: { rackName: createDto.rackName,rackCode: createDto.rackCode, rackType: createDto.rackType } });
      if (record) {
        return new CommonResponseModel(false, 0, 'Record already exists with this rack position code');
      }
      const entity: RacksEntity = this.adapter.convertDtoToEntity(createDto);
      const count: RacksEntity = await this.repository.save(entity);
      const saveDto: RacksDTO = this.adapter.convertEntityToDto(count);

      return new CommonResponseModel(true, 1, 'Data saved successfully', saveDto);
    } catch (error) {
      return new CommonResponseModel(false, 0, error)
    }
  }

  async getRacks(): Promise<CommonResponseModel> {
    const records = await this.repository.find({order:{"plantInfo":{"plantName":"ASC"}},relations:['plantInfo']});
    if (records.length)
      return new CommonResponseModel(true, 65441, "Data Retrieved Successfully", records)
    else
      return new CommonResponseModel(false, 0, 'No data found')
  }

  async activateOrDeactivateRacks(req: RackCreateRequest): Promise<CommonResponseModel> {
    try {
      const record = await this.repository.findOne({ where: { rackId: req.rackId } });
      await this.repository.update({ rackId: req.rackId }, { isActive: !record.isActive });
      const internalMessage: string = !record.isActive ? "Activated Sucessfully" : "DeActivated Sucessfully"
      return new CommonResponseModel(true, 6876, internalMessage)
    } catch (error) {
      return new CommonResponseModel(false, 0, error)
    }
  }
  async getRackPositionQrs(req:RackIdReq): Promise<CommonResponseModel> {
    try {
        const data: RacksDTO[] = await this.repository
            .createQueryBuilder('r')
            .select(' r.rack_id,r.rack_name,r.rack_code,position_code')
            .leftJoin(RackPositionEntity,'rp',` rp.rack_id = r.rack_id`)
            .where(`r.rack_id = '${req.rackId}'`)
            .getRawMany();
  
        if (data && data.length > 0) {
            const response = new CommonResponseModel(true, 11108, "RackPositions retrieved successfully", data);
            return response;
        } else {
            throw new CommonResponseModel(false,99998, 'Data not found');
        }
    } catch (err) {
        return err;
    }
  }
  async getRackWiseUints(req:UnitReq):Promise<CommonResponseModel>{
    try{
      let query=`select p.plant_Name as unit,unit as unitId from racks r left join plants p on p.plant_id=r.unit where r.unit is not null`
      if(req.role === "samplingAdmin"){
        query=query
      }else{
        query=query+` and r.unit=${req.unitId}`
      }
      const res =await this.repository.query(query)
      if(res){
        return new CommonResponseModel(true,1,'Data Retrived Sucessfully',res)
      }else{
        return new CommonResponseModel(false,0,'No data Found',[])
      }

    }catch(err){
      throw err
    }
  }
  async getRackWiseUintsfornegative(req: UnitReq): Promise<CommonResponseModel> {
    try {
      let query = `
        SELECT p.plant_Name AS unit, r.unit AS unitId 
        FROM racks r 
        LEFT JOIN plants p ON p.plant_id = r.unit 
        WHERE r.unit IS NOT NULL
      `;
      
      // Only add the unitId condition if req.unitId is defined
      if (req.role !== "samplingAdmin" && req.unitId !== undefined) {
        query += ` AND r.unit = ${req.unitId}`;
      }
  
      const res = await this.repository.query(query);
      if (res) {
        return new CommonResponseModel(true, 1, 'Data Retrieved Successfully', res);
      } else {
        return new CommonResponseModel(false, 0, 'No data Found', []);
      }
  
    } catch (err) {
      throw err;
    }
  }
  
  async getRacksbyUnit(req:UnitReq): Promise<CommonResponseModel> {

    const records = await this.repository.find({
      relations: ["plantInfo"],
      where: {
          plantInfo: { plantId: req.unitId },rackType: req.rackType,},
      order: {
        rackCode: "ASC",
    },
  });
    if (records.length)
      return new CommonResponseModel(true, 65441, "Data Retrieved Successfully", records)
    else
      return new CommonResponseModel(false, 0, 'No data found')
  }

  async getAllStockByrack(req:Rackreq): Promise<CommonResponseModel> {
    // console.log(req,"req")

    let getBuyerByIds
    if(req.externalRefNo != undefined && req.externalRefNo != 'admin' && req.externalRefNo != ""){
        let employeId = await this.employeeDetailsRepo.findOne({where:{emial:req.email}});
        console.log(employeId)
        getBuyerByIds = await this.employeeBuyerMappingService.getMappedBuyers({employeeId:employeId?.employeeId});
        console.log(getBuyerByIds)
    }
    let query=`SELECT  s.item_type as itemType,mi.m3_code as m3Code, mt.description,mi.description,u.uom AS uomName,s.id AS stockId,s.quantity-s.allocatd_quantity AS stcQnuantity,mi.hsn_code AS hsnCode,mi.item_code AS m3ItemCode,mt.item_code AS m3ItemCode,b.buyer_name AS buyerName,g.grn_number AS grnNumber,r.rack_id AS rackId,s.quantity,rp.position_id AS rackPositionId,rp.rack_position_name AS rackPositionName,rp.position_code AS positionCode,
        rp.preffered_storage_material AS materialType,s.m3_item AS m3ItemId,s.buyer_id AS buyerId,s.xl_no AS xlNo,s.gsm,s.width
        FROM stocks s
        LEFT JOIN rack_position rp ON rp.position_Id=s.location_id
        LEFT JOIN racks r ON r.rack_id=rp.rack_id
        LEFT JOIN grn_items gi ON gi.grn_item_id=s.grn_item_id
        LEFT JOIN grn g ON g.grn_id=gi.grn_id
        LEFT JOIN buyers b ON b.buyer_id=s.buyer_id
        LEFT JOIN m3_items mi ON mi.m3_items_Id=s.m3_item 
        LEFT JOIN m3_trims mt ON mt.m3_trim_Id=s.m3_item 
        LEFT JOIN uom u ON u.id=s.uom_id
        WHERE r.rack_id = ${req.rackId} AND s.plant_id = ${req.plantId} AND s.quantity-s.allocatd_quantity-s.dc_quantity-s.negative_stock >0`
        if(req.externalRefNo != undefined && req.externalRefNo != "admin"){
          query += ` AND s.buyer_id IN (${getBuyerByIds?.data?.buyerIds})`;
        }
        if(req.itemtype === 'FABRIC' && req.itemtype != undefined){
          query=query+` and s.item_type="FABRIC"`
        }if(req.itemtype != 'FABRIC' && req.itemtype != undefined){
          query=query+` and s.item_type not in ("FABRIC")`
        }
        if(req.rackPositionId != undefined){
          query=query+`  and rp.position_Id=${req.rackPositionId}`
        }
        const records = await this.repository.query(query)
    if (records.length)
      return new CommonResponseModel(true, 65441, "Data Retrieved Successfully", records)
    else
      return new CommonResponseModel(false, 0, 'No data found')
  }

  async getAllStockByNegative(req: Rackreq): Promise<CommonResponseModel> {
    console.log(req, "alnegative ----------------req");
  
    let getBuyerByIds
    if(req.externalRefNo != undefined && req.externalRefNo != 'admin' && req.externalRefNo != "" && req.externalRefNo != null){
        let employeId = await this.employeeDetailsRepo.findOne({where:{emial:req.email}});
        console.log(employeId)
        getBuyerByIds = await this.employeeBuyerMappingService.getMappedBuyers({employeeId:employeId?.employeeId});
        console.log(getBuyerByIds)
    }
    let query = `SELECT s.item_type as itemType, mi.m3_code as m3Code, mt.description, mi.description, 
      u.uom AS uomName, s.id AS stockId, 
      s.quantity - s.allocatd_quantity - s.dc_quantity - s.negative_stock AS stcQnuantity, 
      mi.hsn_code AS hsnCode, mi.item_code AS m3ItemCode, 
      mt.item_code AS m3ItemCode, b.buyer_name AS buyerName, 
      g.grn_number AS grnNumber, r.rack_id AS rackId, s.quantity, 
      rp.position_id AS rackPositionId, rp.rack_position_name AS rackPositionName, 
      rp.position_code AS positionCode, rp.preffered_storage_material AS materialType, 
      s.m3_item AS m3ItemId, s.buyer_id AS buyerId, s.xl_no AS xlNo, 
      s.gsm, s.width
      FROM stocks s
      LEFT JOIN rack_position rp ON rp.position_Id = s.location_id
      LEFT JOIN racks r ON r.rack_id = rp.rack_id
      LEFT JOIN grn_items gi ON gi.grn_item_id = s.grn_item_id
      LEFT JOIN grn g ON g.grn_id = gi.grn_id
      LEFT JOIN buyers b ON b.buyer_id = s.buyer_id
      LEFT JOIN m3_items mi ON mi.m3_items_Id = s.m3_item 
      LEFT JOIN m3_trims mt ON mt.m3_trim_Id = s.m3_item 
      LEFT JOIN uom u ON u.id = s.uom_id
      WHERE r.rack_id = ${req.rackId} 
      AND s.plant_id = ${req.plantId} 
      AND s.quantity - s.allocatd_quantity-s.dc_quantity-s.negative_stock > 0`;
  
    if(req.externalRefNo != undefined && req.externalRefNo != 'admin' && req.externalRefNo != "" && req.externalRefNo != null){
      query += ` AND s.buyer_id IN (${getBuyerByIds?.data?.buyerIds})`;
    }
    if (req.itemtype === 'FABRIC' && req.itemtype != null) {
      query += ` AND s.item_type = "FABRIC"`;
    } else if (req.itemtype !== 'FABRIC' && req.itemtype != null) {
      query += ` AND s.item_type NOT IN ("FABRIC")`;
    }
  
    if (req.rackPositionId !== undefined) {
      query += ` AND rp.position_Id = ${req.rackPositionId}`;
    }
  
    query += ` ORDER BY g.grn_number ASC`;

    const records = await this.repository.query(query);
  
    if (records.length) {
      return new CommonResponseModel(true, 65441, "Data Retrieved Successfully", records);
    } else {
      return new CommonResponseModel(false, 0, 'No data found');
    }
  }
    
}




